export default function AgendaStep7Examenes() {

  return (
    <>
      <div>
        <div className="agenda-container">
          <div className="agenda-medico-bar mw-450 centro mt-40 mb-10 wmax-352 mx-auto">
            <div className="mx-auto w-48">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 21H5C3.9 21 3 22 3 23.2V28.8C3 30 3.9 31 5 31H8V17.3C8 9.9 15.4 2 24.5 2C33.6 2 41 10 41 17.3V25"
                  stroke="#0098D8" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M41 21H43C44.1 21 45 22 45 23.2V28.8C45 30 44.1 31 43 31H41" stroke="#0098D8" stroke-width="2"
                      stroke-miterlimit="10"/>
                <path d="M37 25V28C37 31.6 35.1 36.3 32 38.6" stroke="#0098D8" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M18 9C18 16 31.9 25 39 25" stroke="#0098D8" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M19 13C16 14.2 12 19.8 12 24V28C12 32.4 15.1 37.7 20.1 40" stroke="#0098D8" stroke-width="2"
                      stroke-miterlimit="10"/>
                <path
                  d="M29 43C29 44.1 28.1 45 27 45H24C22.9 45 22 44.1 22 43C22 41.9 22.9 41 24 41H27C28.1 41 29 41.9 29 43Z"
                  stroke="#0098D8" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M28 43H29.2C35.7 43 41 37.7 41 31.2V28" stroke="#0098D8" stroke-width="2" stroke-miterlimit="10"/>
              </svg>
            </div>

            <h4 className="text-center fw-700 fz-16 lh-24">Gracias por comunicarte con nosotros</h4>
            <p className="text-center fw-400 fz-13 lh-20 mb-20">Un ejecutivo especialista se pondrá en contacto contigo a la brevedad.</p>

            <a href="/dashboard" className="button-blue btn mt-20 mx-auto d-block text-center decoration-none">SEGUIR NAVEGANDO</a>
          </div>
        </div>
      </div>
    </>
  );
}
